import { render } from "./BlckInfo.vue?vue&type=template&id=32bf09a4&scoped=true"
import script from "./BlckInfo.vue?vue&type=script&lang=js"
export * from "./BlckInfo.vue?vue&type=script&lang=js"

import "./BlckInfo.vue?vue&type=style&index=0&id=32bf09a4&scoped=true&lang=css"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bf09a4"]])

export default __exports__